export default {
    productGroups: { list: [], edit: {}, create: { products: {} } }
};
